import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdfIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.305,
	height: 22.02,
	viewBox: "0 0 18.305 22.02",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "pdf-icon",
		transform: "translate(-229 -431)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "icon-back",
			transform: "translate(229 431)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "back-shape",
					d: "M31.276,1.685H21.5a1.282,1.282,0,0,0-1.282,1.282V22.423A1.282,1.282,0,0,0,21.5,23.7H35.41a1.282,1.282,0,0,0,1.282-1.282V7.1Z",
					transform: "translate(-18.387 -1.685)",
					fill: "#f7f6f8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner-shadow",
					d: "M160.554,61.4h3.74v3.74Z",
					transform: "translate(-145.99 -55.98)",
					fill: "#eae9ec"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner",
					d: "M142.07,1.685V5.82a1.3,1.3,0,0,0,1.3,1.282h4.117Z",
					transform: "translate(-129.182 -1.685)",
					fill: "#d7d6db"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "block_shadow",
					"data-name": "block shadow",
					d: "M34.917,129.774v-7.125a.58.58,0,0,0-.58-.58H20.221v8.285H34.337a.58.58,0,0,0,.58-.58",
					transform: "translate(-18.387 -111.149)",
					fill: "#dee2e6"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "color_block",
					"data-name": "color block",
					d: "M15.95,125.635H.58a.649.649,0,0,1-.58-.7v-8.6a.649.649,0,0,1,.58-.7H15.95a.649.649,0,0,1,.58.7v8.6a.649.649,0,0,1-.58.7",
					transform: "translate(0 -107.299)",
					fill: "#d10020"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3131",
			"data-name": "Path 3131",
			d: "M-6.055,0h.616c.2,0,.28-.084.28-.287V-1.54h.63c1.414,0,2.149-.616,2.149-1.806s-.742-1.806-2.149-1.806H-6.055c-.2,0-.28.084-.28.287V-.287C-6.335-.084-6.251,0-6.055,0Zm.9-2.562V-4.13h.651c.6,0,.9.273.9.784s-.3.784-.9.784ZM-1.323,0H.259C1.9,0,2.548-.721,2.548-2.576S1.9-5.152.259-5.152H-1.323c-.2,0-.28.084-.28.287V-.287C-1.6-.084-1.519,0-1.323,0Zm.9-1.071v-3.01H.266c.784,0,1.043.371,1.043,1.5s-.259,1.5-1.043,1.5ZM3.759,0h.616c.2,0,.28-.084.28-.287V-1.8H6.146c.2,0,.287-.091.287-.287v-.49c0-.21-.084-.287-.287-.287H4.655V-4.081H6.461c.2,0,.287-.084.287-.287v-.5c0-.2-.084-.287-.287-.287h-2.7c-.2,0-.28.084-.28.287V-.287C3.479-.084,3.563,0,3.759,0Z",
			transform: "translate(236.938 446.852)",
			fill: "#fff"
		})]
	})
});
export default SvgPdfIcon;
